import { featureCollection, multiLineString } from '@turf/helpers';
import { getLineColor, getLines, getSegments, decodeSegmentLngLat } from '../../at_map_helpers';

const buildAtMapProps = atMap => {
  const { ID, id, created_at, metadata, name, presentationType, slug, trail_id, trailId, type } = atMap;
  return {
    ID: ID || id,
    created_at: metadata ? metadata.created : created_at,
    isVerifiedMap: type === 'AtVerifiedMap',
    name,
    slug,
    trailId: trailId || trail_id,
    type: presentationType || 'track'
  };
};

// Note: explore if it makes sense to combine start/end markers, photos, waypoints, etc. into single Geojson source
// Pros: easier to switch in/out atMap data
// Cons: less flexibility / modularity
// Layers would need to be filtered like ['==', $type, 'LineString']
// https://docs.mapbox.com/help/troubleshooting/mapbox-gl-js-performance/#combine-vector-tile-sources
const atMapsToGeojson = (atMaps, includeProps) => {
  const features = [];
  atMaps.forEach(atMap => {
    if (!atMap) {
      return;
    }
    let atMapProps;
    if (includeProps) {
      atMapProps = buildAtMapProps(atMap);
    }
    getLines(atMap).forEach(atLine => {
      const coordinates = [];
      const color = getLineColor(atLine);
      const lineId = atLine.id;
      getSegments(atLine).forEach(segment => {
        const lngLats = decodeSegmentLngLat(segment);
        if (lngLats.length > 0) {
          // Collect segment lngLats as coordinates for multiLineString
          coordinates.push(lngLats);
        }
      });
      if (coordinates.length > 0) {
        features.push(multiLineString(coordinates, { ...atMapProps, color, lineId }));
      }
    });
  });
  return featureCollection(features);
};

export { atMapsToGeojson };
